import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import { isIE } from "react-device-detect";
import IdleTimer from "react-idle-timer";

import { setPermissions, setAccountInfo, logout } from "../../reducers/user/actions";
import { getUserToken } from "../../reducers/user/selectors";

import Home from "../../containers/Home/Home";
import { NotFound } from "../../containers/Static/NotFound";
import PatientInformationSheet from "../../containers/PatientInformationSheet/PatientInformationSheet";
import PatientInformationSheetVisual from "../../containers/PatientInformationSheet/PatientInformationSheetVisual";
import PatientInformationSheetText from "../../containers/PatientInformationSheet/PatientInformationSheetText";
import Consent from "../../containers/Consent/Consent";
import ConsentType2 from "../../containers/ConsentType2/ConsentType2";
import ConsentTypeSunnybrook from "../../containers/ConsentTypeSunnybrook/ConsentTypeSunnybrook";
import ConsentTypeTorontoUH from "../../containers/ConsentTypeTorontoUH/ConsentTypeTorontoUH";
import ConsentTypeOttawa from "../../containers/ConsentTypeOttawa/ConsentTypeOttawa";
import ConsentTypeRoyal from "../../containers/ConsentTypeRoyal/ConsentTypeRoyal";
import ConsentTypeRoyalUniversity from "../../containers/ConsentTypeRoyalUniversity/ConsentTypeRoyalUniversity";
import ConsentTypeKelowna from "../ConsentTypeKelowna/ConsentTypeKelowna";
import ConsentTypeMontreal from "../ConsentTypeMontreal/ConsentTypeMontreal";
import ConsentTypeChus from "../ConsentTypeChus/ConsentTypeChus";
import ConsentTypeQuebecChu from "../ConsentTypeQuebecChu/ConsentTypeQuebecChu";
import ConsentTypeWinnipeg from "../ConsentTypeWinnipeg/ConsentTypeWinnipeg";
import ConsentTypeUhn from "../ConsentTypeUhn/ConsentTypeUhn";
import ConsentTypeLhs from "../ConsentTypeLhs/ConsentTypeLhs";
import ConsentTypeHalifax from "../ConsentTypeHalifax/ConsentTypeHalifax";
import ConsentTypePei from "../ConsentTypePei/ConsentTypePei";
import ConsentTypeGreyNuns from "../ConsentTypeGreyNuns/ConsentTypeGreyNuns";
import ConsentTypeRedDeerCalgary from "../ConsentTypeRedDeerCalgary/ConsentTypeRedDeerCalgary";
import ConsentTypeMedicineHat from "../ConsentTypeMedicineHat/ConsentTypeMedicineHat";
import ConsentTypeLethbridge from "../ConsentTypeLethbridge/ConsentTypeLethbridge";
import ConsentTypeKingston from "../ConsentTypeKingston/ConsentTypeKingston";
import ConsentTypeHamilton from "../ConsentTypeHamilton/ConsentTypeHamilton";
import ConsentError from "../ConsentError/ConsentError";
import PhysicianScript from "../../containers/PhysicianScript/PhysicianScript";
import Randomize from "../../containers/Randomize/Randomize";
import ValidateRandomization from "../../containers/ValidateRandomization/ValidateRandomization";
import SaeRecording from "../../containers/SaeRecording/SaeRecording";
import Documents from "../../containers/Documents/Documents";
import ContactUs from "../../containers/ContactUs/ContactUs";

import Login from "../../containers/Login/Login";
import ResetPassword from "../../containers/ResetPassword/ResetPassword";
import ResetPasswordSend from "../../containers/ResetPasswordSend/ResetPasswordSend";
import SetAccountPassword from "../../containers/SetAccountPassword/SetAccountPassword";
import AdminDashboard from "../../containers/AdminDashboard/AdminDashboard";
import PatientProfile from "../../containers/PatientProfile/PatientProfile";
import SAEReporting from "../../containers/SAEReporting/SAEReporting";
import FollowUp90Day from "../../containers/FollowUp90Day/FollowUp90Day";
import MyProfile from "../../containers/MyProfile/MyProfile";
import Enrolments from "../../containers/Enrolments/Enrolments";
import AdminSettings from "../../containers/AdminSettings/AdminSettings";
import SettingsSites from "../../containers/SettingsSites/SettingsSites";
import SettingsUsers from "../../containers/SettingsUsers/SettingsUsers";
import SettingsUsersBulk from "../../containers/SettingsUsersBulk/SettingsUsersBulk";
import SettingsRoles from "../../containers/SettingsRoles/SettingsRoles";
import DocumentsEditor from "../../containers/DocumentsEditor/DocumentsEditor";
import SettingsConsent from "../../containers/SettingsConsent/SettingsConsent";
import DocumentsTraining from "../../containers/DocumentsTraining/DocumentsTraining";
import DocumentsPublic from "../../containers/DocumentsPublic/DocumentsPublic";
import SettingsUserRoles from "../../containers/SettingsUserRoles/SettingsUserRoles";
import SettingsGeneral from "../../containers/SettingsGeneral/SettingsGeneral";
import AuditLogs from "../../containers/AuditLogs/AuditLogs";
import Simulation from "../../containers/Simulation/Simulation";
import Training from "../../containers/Training/Training";
import Newsletter from "../../containers/Newsletter/Newsletter";
import Reporting from "../Reporting/Reporting";
import classNames from "classnames";

import classes from "./App.css";
import ConsentTypeVancouver from "../ConsentTypeVancouver/ConsentTypeVancouver";
// import ConsentTypeMedicineHatCalgary from "../ConsentTypeMedicineHatCalgary/ConsentTypeMedicineHatCalgary";

const routes = require("../../routes.json");

class App extends React.Component {
  constructor(props) {
    super(props);

    this.idleTimer = null;

    this.handleOnIdle = this.handleOnIdle.bind(this);

    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    if (this.props.token) {
      this.props.setPermissions(this.props.token);
      this.props.setAccountInfo(this.props.token);
    }
  }

  handleOnIdle(event) {
    if (this.props.token && process.env.NODE_ENV !== "development") {
      this.props.logout();
    }
  }

  render() {
    if (isIE)
      return (
        <div
          className={classNames(
            classes.errorBox,
            classes.alert,
            classes.verticalCenter
          )}
        >
          <div className={classes.msg}>
            Error &#8211; We noticed that you may be using Internet Explorer as
            your browser. Unfortunately, this browser does not support the
            latest features used in our application. Please switch to a modern
            browser such as Microsoft Edge, Google Chrome, or Mozilla Firefox.
            Thank you for understanding!
          </div>
        </div>
      );

    return (
      <React.Fragment>
        {this.props.token && (
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            timeout={1000 * 60 * 10}
            onIdle={this.handleOnIdle}
            debounce={250}
          />
        )}
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route
              exact
              path="/patient-information-sheet"
              component={PatientInformationSheet}
            />
            <Route
              exact
              path="/patient-information-sheet-visual"
              component={PatientInformationSheetVisual}
            />
            <Route
              exact
              path="/patient-information-sheet-text"
              component={PatientInformationSheetText}
            />
            <Route exact path="/consent" component={Consent} />
            <Route exact path="/consent/:token" component={Consent} />
            <Route
              exact
              path={routes.front.consentType2}
              component={ConsentType2}
            />
            <Route
              exact
              path={routes.front.consentType2Token}
              component={ConsentType2}
            />
            <Route
              exact
              path={routes.front.consentTypeSunnybrook}
              component={ConsentTypeSunnybrook}
            />
            <Route
              exact
              path={routes.front.consentTypeSunnybrookToken}
              component={ConsentTypeSunnybrook}
            />
            <Route
              exact
              path={routes.front.consentTypeTorontoUH}
              component={ConsentTypeTorontoUH}
            />
            <Route
              exact
              path={routes.front.consentTypeTorontoUHToken}
              component={ConsentTypeTorontoUH}
            />
            <Route
              exact
              path={routes.front.consentTypeOttawa}
              component={ConsentTypeOttawa}
            />
            <Route
              exact
              path={routes.front.consentTypeOttawaToken}
              component={ConsentTypeOttawa}
            />
            <Route
              exact
              path={routes.front.consentTypeRoyal}
              component={ConsentTypeRoyal}
            />
            <Route
              exact
              path={routes.front.consentTypeRoyalToken}
              component={ConsentTypeRoyal}
            />
            <Route
              exact
              path={routes.front.consentTypeRoyalUniversity}
              component={ConsentTypeRoyalUniversity}
            />
            <Route
              exact
              path={routes.front.consentTypeRoyalUniversityToken}
              component={ConsentTypeRoyalUniversity}
            />
            <Route
              exact
              path={routes.front.consentTypeKelowna}
              component={ConsentTypeKelowna}
            />
            <Route
              exact
              path={routes.front.consentTypeKelownaToken}
              component={ConsentTypeKelowna}
            />
            <Route
              exact
              path={routes.front.consentTypeMontreal}
              component={ConsentTypeMontreal}
            />
            <Route
              exact
              path={routes.front.consentTypeMontrealToken}
              component={ConsentTypeMontreal}
            />
            <Route
              exact
              path={routes.front.consentTypeVancouver}
              component={ConsentTypeVancouver}
            />
            <Route
              exact
              path={routes.front.consentTypeChus}
              component={ConsentTypeChus}
            />
            <Route
              exact
              path={routes.front.consentTypeChusToken}
              component={ConsentTypeChus}
            />
            <Route
              exact
              path={routes.front.consentTypeQuebecChu}
              component={ConsentTypeQuebecChu}
            />
            <Route
              exact
              path={routes.front.consentTypeQuebecChuToken}
              component={ConsentTypeQuebecChu}
            />
            <Route
              exact
              path={routes.front.consentTypeWinnipeg}
              component={ConsentTypeWinnipeg}
            />
            <Route
              exact
              path={routes.front.consentTypeWinnipegToken}
              component={ConsentTypeWinnipeg}
            />
            <Route
              exact
              path={routes.front.consentTypeUhn}
              component={ConsentTypeUhn}
            />
            <Route
              exact
              path={routes.front.consentTypeUhnToken}
              component={ConsentTypeUhn}
            />
            <Route
              exact
              path={routes.front.consentTypeHalifax}
              component={ConsentTypeHalifax}
            />
            <Route
              exact
              path={routes.front.consentTypeHalifaxToken}
              component={ConsentTypeHalifax}
            />
            <Route
              exact
              path={routes.front.consentTypePei}
              component={ConsentTypePei}
            />
            <Route
              exact
              path={routes.front.consentTypePeiToken}
              component={ConsentTypePei}
            />
            <Route
              exact
              path={routes.front.consentTypeLhs}
              component={ConsentTypeLhs}
            />
            <Route
              exact
              path={routes.front.consentTypeLhsToken}
              component={ConsentTypeLhs}
            />
            <Route
              exact
              path={routes.front.consentTypeGreyNuns}
              component={ConsentTypeGreyNuns}
            />
            <Route
              exact
              path={routes.front.consentTypeGreyNunsToken}
              component={ConsentTypeGreyNuns}
            />
            <Route
              exact
              path={routes.front.consentTypeRedDeer}
              component={ConsentTypeRedDeerCalgary}
            />
            <Route
              exact
              path={routes.front.consentTypeRedDeerToken}
              component={ConsentTypeRedDeerCalgary}
            />
            <Route
              exact
              path={routes.front.consentTypeMedicineHat}
              component={ConsentTypeMedicineHat}
            />
            <Route
              exact
              path={routes.front.consentTypeMedicineHatToken}
              component={ConsentTypeMedicineHat}
            />
            <Route
              exact
              path={routes.front.consentTypeLethbridge}
              component={ConsentTypeLethbridge}
            />
            <Route
              exact
              path={routes.front.consentTypeLethbridgeToken}
              component={ConsentTypeLethbridge}
            />
            <Route
              exact
              path={routes.front.consentTypeKingston}
              component={ConsentTypeKingston}
            />
            <Route
              exact
              path={routes.front.consentTypeKingstonToken}
              component={ConsentTypeKingston}
            />
            <Route
              exact
              path={routes.front.consentTypeHamilton}
              component={ConsentTypeHamilton}
            />
            <Route
              exact
              path={routes.front.consentTypeHamiltonToken}
              component={ConsentTypeHamilton}
            />
            <Route
              exact
              path={routes.front.consentInvalid}
              component={ConsentError}
            />
            <Route exact path="/physician-script" component={PhysicianScript} />
            <Route exact path="/randomize" component={Randomize} />
            <Route
              exact
              path="/validate-randomization"
              component={ValidateRandomization}
            />
            <Route exact path="/sae-recording" component={SaeRecording} />
            <Route exact path="/documents" component={Documents} />
            <Route exact path="/contact-us" component={ContactUs} />
            <Route exact path={routes.admin.index}>
              <Redirect to={routes.admin.dashboard} />
            </Route>
            <Route exact path={routes.admin.login} component={Login} />
            <Route
              exact
              path={routes.admin.resetPassword}
              component={ResetPassword}
            />
            <Route
              exact
              path={routes.admin.resetPasswordConfirm}
              component={ResetPasswordSend}
            />
            <Route
              exact
              path={routes.admin.setPassword}
              component={SetAccountPassword}
            />
            <Route
              exact
              path={routes.admin.dashboard}
              component={AdminDashboard}
            />
            <Route
              exact
              path={routes.admin.patientProfile}
              component={PatientProfile}
            />
            <Route
              exact
              path={routes.admin.patientProfileSingle}
              component={PatientProfile}
            />
            <Route
              exact
              path={routes.admin.saeReporting}
              component={SAEReporting}
            />
            <Route
              exact
              path={routes.admin.saeReportingSignle}
              component={SAEReporting}
            />
            <Route
              exact
              path={routes.admin.followUp90Day}
              component={FollowUp90Day}
            />
            <Route
              exact
              path={routes.admin.followUp90DaySingle}
              component={FollowUp90Day}
            />
            <Route exact path={routes.admin.myProfile} component={MyProfile} />
            <Route
              exact
              path={routes.admin.enrolments}
              component={Enrolments}
            />
            <Route
              exact
              path={routes.admin.settings}
              component={AdminSettings}
            />
            <Route
              exact
              path={routes.admin.settingsSites}
              component={SettingsSites}
            />
            <Route
              exact
              path={routes.admin.settingsUsers}
              component={SettingsUsers}
            />
            <Route
              exact
              path={routes.admin.settingsUsersBulk}
              component={SettingsUsersBulk}
            />
            <Route
              exact
              path={routes.admin.settingsRoles}
              component={SettingsRoles}
            />
            <Route
              exact
              path={routes.admin.documentsEditor}
              component={DocumentsEditor}
            />
            <Route
              exact
              path={routes.admin.consentEditor}
              component={SettingsConsent}
            />
            <Route
              exact
              path={routes.admin.documentsTraining}
              component={DocumentsTraining}
            />
            <Route
              exact
              path={routes.admin.documentsPublic}
              component={DocumentsPublic}
            />
            <Route
              exact
              path={routes.admin.settingsUsersRoles}
              component={SettingsUserRoles}
            />
            <Route
              exact
              path={routes.admin.settingsGeneral}
              component={SettingsGeneral}
            />
            <Route exact path={routes.admin.auditLogs} component={AuditLogs} />
            <Route
              exact
              path={routes.admin.simulation}
              component={Simulation}
            />
            <Route exact path={routes.admin.training} component={Training} />
            <Route
              exact
              path={routes.admin.newsletter}
              component={Newsletter}
            />
            <Route exact path={routes.admin.reporting} component={Reporting} />
            <Route exact path="*" component={NotFound} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
});

const mapDispatchToProps = {
  setPermissions,
  setAccountInfo,
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js